module.exports = __webpack_public_path__ + "assets/9139e8234ecc046f02d89f02bead656c.json";